import * as TYPES from './mutationTypes'

export default {
  //列表
  [TYPES.GET_CROSS_CHAIN](state, payload) {
    const { limit, offset, total } = payload.result
    Object.assign(state, {
      crosschain_list: payload.result.items,
      crosschain_paging: { limit, offset, total }
    })
  }
}
